import { requestApi } from '~/services/api.js';

export async function getTemporaryPlayerSimple() {
	try {
		const response = await requestApi(`/temporary/player`);
		/* 
		{
			"status": "SUCCESS",
			"result": {
					"playerId": "386c6cd0224544e84cec1f964051bf79",
					"temporary": true,
					"expired": false,
					"startTime": 1667229232000
			}
		}
		*/
		return response;
	} catch {
		return {
			errorCode: 'ERROR_TEMPORARY_ACCOUNT_API',
			status: 'FAILURE'
		};
	}
}

export async function getTemporaryPlayer(playerId) {
	try {
		const response = await requestApi(`/temporary/player?playerId=${playerId}`);
		/* 
		{
			"status": "SUCCESS",
			"result": {
					"playerId": "386c6cd0224544e84cec1f964051bf79",
					"temporary": true,
					"expired": false,
					"startTime": 1667229232000
			}
		}
		*/
		return response;
	} catch {
		return {
			errorCode: 'ERROR_TEMPORARY_ACCOUNT_API',
			status: 'FAILURE'
		};
	}
}
